import { useEffect, useMemo, useState } from "react";

const Duck = ({ n, win }) => (
  <span className={`relative inline-flex h-8 w-10 items-center justify-center ${win ? "scale-125" : ""}`}>
    <svg viewBox="0 0 40 32" className="absolute inset-0 h-full w-full" aria-hidden>
      <ellipse cx="18" cy="22" rx="16" ry="8" fill={win ? "#facc15" : "#fde047"} stroke="#0f172a" strokeWidth="2" />
      <circle cx="29" cy="11" r="7" fill={win ? "#facc15" : "#fde047"} stroke="#0f172a" strokeWidth="2" />
      <path d="M35 11l5 2-5 2z" fill="#f97316" stroke="#0f172a" strokeWidth="1.5" />
      <circle cx="31" cy="9" r="1.4" fill="#0f172a" />
    </svg>
    <span className="relative mt-2 text-[10px] font-black">{n}</span>
  </span>
);

// Animated race: the sealed winner always crosses the line first.
export const DuckRace = ({ winner, sold }) => {
  const lanes = useMemo(() => {
    const others = sold.filter((n) => n !== winner).sort(() => Math.random() - 0.5).slice(0, 5);
    return [...others.slice(0, 2), winner, ...others.slice(2)].map((n) => ({ n, end: n === winner ? 92 : 45 + Math.random() * 38 }));
  }, [winner, sold]);
  const [go, setGo] = useState(false);
  useEffect(() => { const t = setTimeout(() => setGo(true), 300); return () => clearTimeout(t); }, []);
  return (
    <div className="space-y-1 border-2 border-slate-900 bg-sky-300 p-2" data-testid="stb-duck-race">
      {lanes.map(({ n, end }) => (
        <div key={n} className="relative h-9 border-b border-dashed border-sky-100/70">
          <div className="absolute top-0 transition-[left] ease-out" style={{ left: go ? `${end}%` : "0%", transitionDuration: n === winner ? "4.2s" : `${3 + Math.random()}s` }}><Duck n={n} win={go && n === winner} /></div>
        </div>
      ))}
      <div className="flex justify-end text-[10px] font-black uppercase text-slate-900">Finish ▸</div>
    </div>
  );
};
